import { useCallback } from 'react';

declare global {
  interface Window {
    Paddle: {
      Environment: {
        set: (env: 'sandbox' | 'production') => void;
      };
      Initialize: (options: { token: string; seller?: number }) => void;
      Checkout: {
        open: (options: Record<string, unknown>) => void;
      };
      Status: {
        libraryVersion: string;
      };
    };
    __paddleReady?: Promise<void>;
  }
}

interface UsePaddleOptions {
  onCheckoutComplete?: () => void;
  onCheckoutClosed?: () => void;
}

export function usePaddle(_options: UsePaddleOptions = {}) {
  const ensurePaddleReady = async () => {
    if (window.__paddleReady) {
      await window.__paddleReady;
    }
    if (!window.Paddle) {
      throw new Error('Paddle.js not loaded');
    }
  };

  const openCheckout = useCallback(async (options: {
    transactionId: string;
  }) => {
    await ensurePaddleReady();

    console.log('Opening Paddle checkout with transactionId:', options.transactionId);

    window.Paddle.Checkout.open({
      transactionId: options.transactionId,
      settings: {
        displayMode: 'overlay',
        locale: 'es',
        theme: 'light',
      },
    });
  }, []);

  const openCheckoutWithItems = useCallback(async (options: {
    priceId: string;
    customData?: Record<string, string>;
  }) => {
    await ensurePaddleReady();

    console.log('Opening Paddle checkout with priceId:', options.priceId);

    window.Paddle.Checkout.open({
      items: [{ priceId: options.priceId, quantity: 1 }],
      customData: options.customData,
      settings: {
        displayMode: 'overlay',
        locale: 'es',
        theme: 'light',
        allowLogout: true,
        showAddDiscounts: true,
        showAddTaxId: true,
      },
    });
  }, []);

  return { openCheckout, openCheckoutWithItems };
}
